<template>
  <div class="ar-header" :style="{ height }">
    <div class="wrap-user-head clearfix">
      <div class="top-img">
        <h3>
          <a href="/">
            <img src="../../../../anystatic/img/logo.png" alt="AR" class="ar_logo"/>
            <span>运维平台</span>
          </a>
        </h3>
      </div>
      <img v-popover:popover class="header-msg" src="../../../../anystatic/img/userpic.png" :alt="admin" :title="admin"/>
      <el-popover ref="popover" placement="top">
        <a class="updatepassword" @click="updatePWD()">个人中心</a><br/>
        <a @click="quit()">退出登录</a>
      </el-popover>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ArHeader',
  componentName: 'ArHeader',

  props: {
    height: {
      type: String,
      default: '60px'
    },
  },
  data(){
    return {
      admin: this.$storage.getStorage('user'),
    } 
  },
  methods:{
    //退出点击事件
    quit(){
			var params = { userId: this.admin }
      this.$post('/signOut', params)
			.then((res) =>{
        this.$storage.removeStorage('user');
				this.$router.push({ path: '/login'})
				this.$message({
					type: 'success',
					message: '退出登录成功！'
				})
			})
			.catch((err)=>{
        console.log(err);
			})
    },
    //修改密码跳转
		updatePWD(){
			this.$router.push({ path: '/system'})
		}
  }
}
</script>
<style lang="scss" scoped>
.wrap-user-head{
  padding-right: 20px;
  position: relative;
  z-index: 2;
  height: 60px;
  width: auto;
  line-height: 60px;
  box-sizing: border-box;
  box-shadow: 0px 2px 6px 0px rgba(129, 129, 129, 0.18);
  user-select: none;
  .top-img{
    width: 200px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    float: left;
    span{
      font-size:19px;
      color: #38A4FF;
      font-weight: bold;
      vertical-align: top;
    }
    .ar_logo{
      display: inline-block;
      width: 32px;
      height:24px;
      line-height: 24px;
      color: #38A4FF;
      background-color: #FFF;
      margin-top: 18px;
    }
  }
  .header-span{
    float: right;
    display: inline-block;
    margin-left: 10px;
    font-size:12px;
    font-weight:400;
    color:rgba(102,102,102,1);
  }
  .header-msg{
    margin-top: 10px;
    float: right;
    cursor: pointer;
    display: inline-block;
    border-radius: 50%;
    border: 1px solid #ccc;
    height: 40px;
    width: 40px;
  }
}
.el-popover{
  min-width: auto;
  width: 80px;
  text-align: center;
  a{
    display: inline-block;
    margin-bottom: 0;
    font-size: 12px;
    cursor: pointer !important;
  }
  .updatepassword{
    margin-bottom: 10px;
  }
  a:hover{
    color: #38A4FF !important;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/anyUI/header/header.vue